
    <nav class="navbar navbar-expand-lg navbar-light bg-light" *ngIf="nav.visible">
        <div class="container container-fluid"  >
          <a class="navbar-brand" >
            <img src="/assets/board_logo.png" class="img" width="50px" height="50px">
            GBSHSE</a>
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
              <span class="navbar-toggler-icon"></span>
            </button>
          <div class="collapse navbar-collapse" id="navbarSupportedContent" >
            <ul class="navbar-nav ml-auto mb-2 mb-lg-0" >
              <li class="nav-item">
                <a class="nav-link" aria-current="page" [routerLink]="['/home']"><b>Home</b></a>
              </li>
              <li class="nav-item dropdown" >
                <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <i class="fa fa-user"></i> {{userDisplayName}} 
                </a>
                <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                  <a class="dropdown-item" [routerLink]="['/change-password']">Change Password</a>
                  <a class="dropdown-item" (click)='logout()' href="#">Logout</a>
                  
                </div>
              </li>
            </ul>
           
          </div>
        </div>
      </nav>
